import React from "react";

import { Typography, TextField, OutlinedInput } from "@material-ui/core";
import { FixedSizeList } from 'react-window'
import {
    useTable,
    // useGroupBy,
    useFilters,
    useSortBy,
    // useExpanded,
    // usePagination,
    useBlockLayout
} from 'react-table';

export default function VirtualizedTable({ columns, data, style, onCellClick, onCellChange = () => { }, onRowChange = () => { }, rowHeight = 30 }) {

    const defaultColumn = React.useMemo(
        () => ({
            width: columns.length < 6 ? 830 / (columns.length - 1) : 250,
            // width: 150,
            Filter: DefaultColumnFilter,
        }),
        []
    )

    columns.forEach(col => {
        if (col.filter == "between") {
            col.Filter = NumberRangeColumnFilter
        }
    })

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        totalColumnsWidth,
        prepareRow,
    } = useTable(
        {
            columns,
            data,
            defaultColumn,
            onCellChange
        },
        useBlockLayout,
        useFilters,
        useSortBy
    )

    const RenderRow = React.useCallback(
        ({ index, style }) => {
            const row = rows[index];
            prepareRow(row)
            const rowComponent = row.cells.map(cell => {
                // if (cell.column.id == "SR_NO") {
                //     return (<div className="td" style={{ width: 200 }}>
                //         {index}
                //     </div>)
                // }
                return (
                    <div {...cell.getCellProps()} className="td" onClick={() => {
                        if (cell.column.isCellClick) {
                            onCellClick(cell.column.raw, cell.value)
                        }
                    }}>
                        <Typography variant="body2">
                            {cell.render('Cell')}
                        </Typography>
                    </div>
                )
            });

            return (
                <div
                    {...row.getRowProps({
                        style,
                    })}
                    className="tr"
                >
                    {row.original.isEditing ?
                        <form onSubmit={function (ev) {
                            let data = Object.fromEntries(new FormData(ev.target).entries());
                            onRowChange(data, index);
                            ev.preventDefault();
                            return false;
                        }}>
                            {rowComponent}
                        </form>
                        : rowComponent
                    }
                </div>
            )
        },
        [prepareRow, rows]
    )

    // Render the UI for your table
    return (
        <div {...getTableProps()} className="table react-table" style={style}>
            {headerGroups.map(headerGroup => (
                <div {...headerGroup.getHeaderGroupProps()} className="tr">
                    {/* <div className="th" style={{ width: 100 }}>  <Typography variant="h6">Sr. No.</Typography> </div> */}
                    {headerGroup.headers.map((column, key) => (
                        <div className="th" {...column.getHeaderProps()}>
                            <div>
                                <div className="noselect" {...column.getSortByToggleProps()}>
                                    <Typography variant="h6">{column.render('Header')}
                                        <span>
                                            {column.isSorted
                                                ? column.isSortedDesc
                                                    ? ' 🔽'
                                                    : ' 🔼'
                                                : ''}
                                        </span>
                                    </Typography>
                                </div>
                                <div className="column_filter" style={{ paddingTop: 10 }}>
                                    {column.canFilter && key > 0 ? column.render('Filter') : null}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ))}
            <FixedSizeList
                height={rows.length < 20 ? rows.length * rowHeight : 500}
                itemCount={rows.length}
                itemSize={rowHeight}
                width={totalColumnsWidth}
                style={{
                    overflow: "overlay"
                }}
            >
                {RenderRow}
            </FixedSizeList>
        </div>
    )
}


function DefaultColumnFilter({
    column: { filterValue, preFilteredRows, setFilter },
}) {
    const count = preFilteredRows.length

    return (
        <TextField
            value={filterValue || ''}
            onChange={e => {
                setFilter(e.target.value || undefined)
            }}
            placeholder={`Search...`}
            style={{
                height: 30,
                marginRight: 5,
            }}
        />
    )
}

function NumberRangeColumnFilter({
    column: { filterValue = [], preFilteredRows, setFilter, id },
}) {
    const [min, max] = React.useMemo(() => {
        let min = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
        let max = preFilteredRows.length ? preFilteredRows[0].values[id] : 0
        preFilteredRows.forEach(row => {
            min = Math.min(row.values[id], min)
            max = Math.max(row.values[id], max)
        })
        return [min, max]
    }, [id, preFilteredRows])

    return (
        <div
        // style={{
        //     display: 'flex',
        // }}
        >
            <TextField
                value={filterValue[0] || ''}
                type="number"
                onChange={e => {
                    const val = e.target.value
                    setFilter((old = []) => [val ? parseInt(val, 10) : undefined, old[1]])
                }}
                placeholder={`Min`}
                style={{
                    width: 80,
                    height: 30,
                    marginRight: 5,
                }}
            />
            <Typography variant="body1" style={{ paddingTop: 10, display: "inline-block" }}>to</Typography>
            <TextField
                value={filterValue[1] || ''}
                type="number"
                onChange={e => {
                    const val = e.target.value
                    setFilter((old = []) => [old[0], val ? parseInt(val, 10) : undefined])
                }}
                placeholder={`Max`}
                style={{
                    width: 80,
                    height: 30,
                    marginLeft: 5,
                    textAlign: 'center'
                }}
            />
        </div>
    )
}